import reducer from './reducer';
import * as actions from './actions';

export default reducer;
export {
  actions,
}
